import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { NotesListComponent, NotesStoreActions, NotesStoreSelectors } from '@era/devices';
import { DevicesRouterStoreSelectors, RouterStoreStates } from '@era/stores';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { Note } from '@rocksoft/mdm-sdk-v2';
import { Observable, Subscription } from 'rxjs';
import { first, tap } from 'rxjs/operators';

@Component({
  selector: 'era-notes-modal',
  templateUrl: './notes-modal.container.html',
  styleUrls: ['./notes-modal.container.scss'],
  imports: [NotesListComponent, AsyncPipe],
})
export class NotesModalComponent implements OnDestroy {
  public readonly currentUdid$: Observable<Note[]>;
  private readonly subscriptions: Subscription[] = [];
  constructor(
    public readonly activeModal: NgbActiveModal,
    private readonly routerStore: Store<RouterStoreStates.RouterState>
  ) {
    this.currentUdid$ = this.routerStore.select(NotesStoreSelectors.selectNotesForCurrentUdid);
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  public noteAdded(note: Note): void {
    this.subscriptions.push(
      this.routerStore
        .select(DevicesRouterStoreSelectors.selectUdid)
        .pipe(
          first(),
          tap((udid) => {
            this.routerStore.dispatch(NotesStoreActions.NotesUIActions.noteAdded({ note, udid }));
          })
        )
        .subscribe()
    );
  }

  public noteDeleted(note: Note): void {
    this.subscriptions.push(
      this.routerStore
        .select(DevicesRouterStoreSelectors.selectUdid)
        .pipe(
          first(),
          tap((udid) => {
            this.routerStore.dispatch(NotesStoreActions.NotesUIActions.noteDeleted({ note, udid }));
          })
        )
        .subscribe()
    );
  }
}
